export default __webpack_public_path__ + "Raleway-Medium.ttf?1a3483dd7a2052f30ede8c556dd3931d";